<template>
  <label class="benefits-toggle-control">
    <input :checked="value" :disabled="disabled" :aria-label="ariaLabel" class="benefits-toggle-input" type="checkbox"
      @change="$emit('input', $event.target.checked)" />

    <span class="benefits-toggle"></span>
  </label>
</template>

<script>
export default {
  name: "BenefitsToggle",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-toggle-control {
  display: inline-flex;
  margin: 0;
  width: max-content;
}

.benefits-toggle-input {
  height: 1px;
  opacity: 0;
  position: absolute;
  width: 1px;
}

.benefits-toggle {
  background: #ffffff;
  border: 0.5px solid #f3f4f6;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  height: 18px;
  padding: 1px 4px;
  position: relative;
  width: 40px;

  &::before {
    background: #d2d6db;
    border: 0.5px solid #9da4ae;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    content: "";
    height: 14px;
    left: 2px;
    position: absolute;
    top: 1px;
    transition: transform 0.15s ease;
    width: 16px;
  }
}

.benefits-toggle-input:checked + .benefits-toggle {
  background: #d3f8e0;
  border-color: #17b26a;

  &::before {
    background: #17b26a;
    border-color: #097347;
    transform: translateX(18px);
  }
}

.benefits-toggle-input:disabled + .benefits-toggle {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
